<template>
  <div class="asc-open-maintenance">
    <div class="asc-open-maintenance--text">
      Select an ID to navigate to a maintenance page or see open maintenance for
      your full fleet.
    </div>
    <div class="asc-open-maintenance--grid">
      <asc-open-maintenance-grid
        :values="items"
        :grid-columns="gridColumns"
        :grid-filters="false"
      ></asc-open-maintenance-grid>
    </div>
    <div class="asc-open-maintenance--button">
      <asc-accent-button
        button-text="See Open Maintenance For Full Fleet"
        block
        :on-click="onOpenFullFleet"
      ></asc-accent-button>
    </div>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscOpenMaintenanceGrid from '@/components/molecules/AscOpenMaintenanceGrid'

export default {
  name: 'AscOpenMaintenance',

  components: {
    AscAccentButton,
    AscOpenMaintenanceGrid,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    tailNumber: {
      type: String,
      default: '',
    },
    gridColumns: {
      type: Array,
      default: () => [],
    },
    onOpenFullFleet: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss">
.asc-open-maintenance {
  &--text {
    margin-bottom: 24px;
  }

  &--grid {
    border: 1px solid $gray-300;
    padding: 16px;
  }

  &--button {
    margin: 24px 0;
  }
}
</style>
